import React        from 'react';
import PropTypes    from 'prop-types';
import { Tooltip }  from 'react-tooltip';
import Translations from '../../../../../utils/Translations';

const Language = (props) => {
    const lang           = props.language.toLowerCase();
    const translationKey = "Language" + lang.charAt(0).toUpperCase() + lang.charAt(1);

    const [showTooltip, setShowTooltip] = React.useState(false);

    const onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowTooltip(!showTooltip);
    };

    React.useEffect(() => {
        if (showTooltip) {
            setTimeout(() => {
                setShowTooltip(false);
            }, 3000);
        }
    }, [showTooltip]);

    return <li className="actor-plate__lang"
               onClick={onClick}
               data-tooltip-content={Translations.get(translationKey)}
               data-tooltip-id={"tooltip-" + props.name}
               onMouseLeave={() => setShowTooltip(false)}
            >
            <span className={"badge-language -lang-" + lang} ></span>
            { !showTooltip && <Tooltip id={"tooltip-" + props.name} place="top" className="custom-react-tooltip" /> }
            { showTooltip && <Tooltip defaultIsOpen={true} openOnClick={true} id={"tooltip-" + props.name} place="top" className="custom-react-tooltip" /> }
    </li>;
};

Language.propTypes = {
    language: PropTypes.string,
    name:     PropTypes.string,
};


export default Language;
